import { useContext, useEffect, useState } from "react"
import { deleteItem, displayData, recodeNow } from "../indexDB/indexDBStora";
import { dataa } from "../../context/data";
import '../../style/components/tableEmp.css';
import { switchh } from "../../context/switch";
import Jobs from '../../data/jobs.json';
import { Link } from "react-router-dom";
import Pagination from "../global/Pagination";
import { config } from "../../context/config";
import { scenes } from "../../context/scenes";
import { collection } from "../../context/collect";
import { action } from "../../context/action";
import { auth } from "../../context/auth";
import { useTransaction } from "../../funcs/hooks/usetransaction";
import { useTranslation } from "react-i18next";


export default function TableEmp () {
    const { t } = useTranslation();
    const { page } = useContext(config);
    const { ActivEmp, user } = useContext(auth);
    const {employees, setEmployees} = useContext(dataa);
    const { setLoadingProcess } = useContext(switchh);
    const { setSceneEmp } = useContext(scenes);
    const { setEmployee } = useContext(collection);
    const {setEditMode} = useContext(action);

    const [refresh, setRefresh] = useState(false);
    const [pagination, setPagination] = useState(0);
    const [search, setSearch] = useState({
        user: "",
        phone: "",
        code: "",
        job: ""
    })
    
    useEffect(() => {
        const getData = async () => {
            setLoadingProcess(true);

            const data = await displayData("employees", page, 5);
            if (data) {
                setEmployees(data);
            } else {
                setEmployees([]);
            }

            setLoadingProcess(false);
            setRefresh(false);
        };

        getData();
    }, [page, refresh]);


    useEffect(() => {
        const countData = async () => {
            const data = await displayData("employees");
            const count = data ? data.length : 0;
            setPagination(Math.ceil(count / 5));
        };        
        countData();
    }, []);


    const showDetails = (code) => {
        if(!code) return;
        const getEmp = employees.find((item) => item.code === code);
        if(getEmp) {
            setSceneEmp(getEmp);
        }
    }

    const delete_transaction = useTransaction("delete");
    
    const deleteEmp = async (code, name) => {
        if(code === ActivEmp.code || ActivEmp.role !== "manager") {
            alert("لا يمكن حذف هذا المستخدم لأنه قيد الاستخدام حاليًا");
            return;
        }
        await deleteItem("employees", code);
        // record message of transaction
        delete_transaction.data.message = `تم حذف الموظف التالي ${name}`;
        await recodeNow(delete_transaction.data, "transactions");
        setRefresh(true);
    }

    const editEmp = (code) => {
        const getEmp = employees.find((item) => item.code === code);
        // reset Pass
        if((getEmp.job === "manager") && ActivEmp.code !== getEmp.code) {
            alert("لا يمكن التعديل على مدير أخر .. يرجى تسجيل الدخول من نفس الحساب");
            return;
        }
        getEmp.password = '';
        setEmployee(getEmp);
        setEditMode(true);
    }   

    return (
        <div>
            <div className="search-emp flex">
                <input onChange={(e) => setSearch((prev)=>({...prev, user: e.target.value}))} type="text" placeholder={t("auth:username")} />
                <input onChange={(e) => setSearch((prev)=>({...prev, code: e.target.value}))} type="text" placeholder={t("auth:code")} />
                <input onChange={(e) => setSearch((prev)=>({...prev, phone: e.target.value}))} type="text" placeholder={t("placeholder:employee.phoneNimSearch")} />
                <select onChange={(e) => setSearch((prev)=>({...prev, job: e.target.value}))}>
                    <option value={''}>{t("label:employee.jobTitle.label")}</option>
                    {Jobs.map((e, i) => 
                        <option key={i} value={e.job}>{t(`jb:${e.job}`)}</option>
                    )}
                </select>
            </div>
            <div className="table">
                <table>
                <thead>
                    <tr>
                        <th>{t("common:id")}</th>
                        <th>{t("common:code")}</th>
                        <th>{t("label:employee.jobTitle.label")}</th>
                        <th>{t("label:employee.salaryType.label")}</th>
                        <th>{t("label:employee.salary")}</th>
                        <th>{t("label:employee.status.label")}</th>
                        <th>{t("label:employee.hasShift")}</th>
                        <th>{t("common:action")}</th>
                    </tr>
                </thead>
                <tbody>
                    {employees
                        ?.filter(e =>
                            (!search.user  || e.user?.toLowerCase().includes(search.user.toLowerCase())) &&
                            (!search.phone || e.details?.phone?.includes(search.phone)) &&
                            (!search.code  || e.code?.toString().includes(search.code)) &&
                            (!search.job   || e.job?.toLowerCase().includes(search.job.toLowerCase()))
                        )
                        .map((e, i) => (
                            <tr key={i}>
                            <td>{i + 1}</td>
                            <td>#{e.code}</td>
                            <td>{`${e.fullName.split(" ")[0]} ${e.fullName.split(" ")[1]}`}</td>
                            <td>{e.job}</td>
                            <td>{e.salary.type}</td>
                            <td>{e.salary.value} {user.data[0]?.currency.code}</td>
                            <td>{e.status ? t("label:employee.status.active") : t("label:employee.status.deactive")}</td>
                            <td>{e.shift.shiftDates ? "🟢" : "🟡"}</td>
                            <td className="flex flex-center-center action">
                                <Link className="warning text-weight-bold" to={`exp/${e.code}`}>{t("common:expenses")}</Link>
                                <button onClick={() => showDetails(e.code)} className="success text-weight-bold">{t("common:details")}</button>
                                <Link className="normal text-weight-bold" to={`workTime/${e.code}`}>{t("common:employee.manageSchedule.head")}</Link>
                                <button onClick={() => deleteEmp(e.code, e.fullName)} className="error text-weight-bold">{t("action:delete")}</button>
                                <button onClick={() => editEmp(e.code)} className="normal text-weight-bold">{t("action:edit")}</button>
                            </td>
                            </tr>
                        ))}
                </tbody>
                </table>
                <Pagination max={pagination} />
            </div>
        </div>
    )
}